import { useState } from "react";
import "./voting.scss";
import SpeakerEach from "./SpeakerEach";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const INITIAL_SPEAKERS = [
  {
    id: 1,
    speaker: "Philip McKernan",
    vote: null,
    comment: "",
    image: "../images/Phillip.webp",
  },
  {
    id: 2,
    speaker: "Anna-Sophie Hartvigsen",
    vote: null,
    comment: "",
    image: "/images/AH.webp",
  },
  {
    id: 3,
    speaker: "Paul Scanlon",
    vote: null,
    comment: "",
    image: "/images/scanlon.webp",
  },
  {
    id: 4,
    speaker: "Jon Penberthy",
    vote: null,
    comment: "",
    image: "/images/jp.webp",
  },
  {
    id: 5,
    speaker: "Gary Rhodes",
    vote: null,
    comment: "",
    image: "/images/GR.webp",
  },
  {
    id: 6,
    speaker: "Sarah Willingham",
    vote: null,
    comment: "",
    image: "/images/SW.webp",
  },
  {
    id: 7,
    speaker: "Liam Ryan",
    vote: null,
    comment: "",
    image: "/images/LR.webp",
  },
  {
    id: 8,
    speaker: "James Watt",
    vote: null,
    comment: "",
    image: "/images/Watt1.webp",
  },
  {
    id: 9,
    speaker: "Dan Peña",
    vote: null,
    comment: "",
    image: "/images/DanPena.webp",
  },
];

export default function Voting() {
  const navigate = useNavigate();
  // const url = "http://localhost:4100";
  const url = "https://dev.pmwevents.com";
  const [speakers, setSpeakers] = useState(INITIAL_SPEAKERS);

  const handleSpeaker = (id, patch) => {
    setSpeakers((prev) =>
      prev.map((s) => (s.id === id ? { ...s, ...patch } : s))
    );
  };

  const handleVote = async () => {
    console.log("click");
    console.log(speakers);

    await axios.post(`${url}/sbc/sbc-voting`, speakers).then((res) => {
      navigate("/vote-thank-you");
    });
  };

  return (
    <main className="voting__main">
      <h2>Rate the SBC25 Speakers!</h2>
      <p>
        We’d love your feedback! Please rate each speaker from 1 to 5 stars —
        with 5 being the highest — and share any comments or suggestions you
        have.
      </p>

      <section className="speaks">
        {speakers.map((speaker) => {
          return (
            <SpeakerEach speaker={speaker} handleSpeaker={handleSpeaker} />
          );
        })}
      </section>
      <button onClick={handleVote}>Vote NOW</button>
    </main>
  );
}
